module.exports = __webpack_public_path__ + "static/media/freedomly-logo-crop.59c68d39.svg";